import React from 'react';
import {Link} from 'react-router-dom';
import {MapPin} from 'lucide-react';
import {PageChangeItem} from '../../api/types';

/**
 * A divider in the conversation: the user moved to another page between two
 * turns. The assistant sees the same line in its history, so what follows is
 * read against the new place. Shows the page title (the full description
 * with ids is in the tooltip) and truncates, so a long place name can never
 * widen the panel.
 */
const PageChangeItemView: React.FC<{item: PageChangeItem}> = ({item}) => {
    const label = item.title || item.description;
    if (!label) {
        return null;
    }

    return (
        <div
            className="d-flex align-items-center gap-2 my-2 small text-muted"
            role="separator"
            aria-label={`Moved to ${label}`}
            style={{minWidth: 0}}
        >
            <hr className="flex-grow-1 my-0" style={{minWidth: 16}} />
            <span
                className="d-inline-flex align-items-center gap-1 text-truncate"
                style={{maxWidth: '70%'}}
                title={item.description}
            >
                <MapPin size={12} className="flex-shrink-0" />
                {item.url ? (
                    <Link to={item.url} className="text-muted text-truncate">
                        {label}
                    </Link>
                ) : (
                    <span className="text-truncate">{label}</span>
                )}
            </span>
            <hr className="flex-grow-1 my-0" style={{minWidth: 16}} />
        </div>
    );
};

export default PageChangeItemView;
